var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6zm0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.845 8.877c-.552.009-1.012-.434-.973-.985.22-3.078 1.666-5.148 2.891-6.215.417-.363 1.03-.198 1.305.281.274.48.11 1.102-.277 1.496-.778.795-1.712 2.244-1.91 4.408-.05.55-.484 1.006-1.036 1.015zm16.224-.324c.552-.007.999-.462.944-1.012-.308-3.07-1.811-5.098-3.067-6.13-.426-.351-1.035-.168-1.296.319-.26.486-.078 1.103.32 1.487.8.772 1.775 2.194 2.034 4.351.066.548.512.992 1.064.985z",
    clipRule: "evenodd"
  })));
};

export default SvgBell;